import { useMap } from "react-map-gl/mapbox";
import { Icon } from "~/components/ui/icons/icon";
import { cn } from "~/lib/utils";
import { ControlGroup } from "./ControlGroup";

/**
 * Custom zoom controls for use in Map.Controls region.
 */
export function ZoomControls() {
  const { current: map } = useMap();

  const handleZoomIn = () => map?.zoomIn();
  const handleZoomOut = () => map?.zoomOut();

  const buttonClass = cn(
    "flex items-center justify-center p-1",
    "text-muted-foreground hover:bg-muted transition-colors",
  );

  return (
    <ControlGroup className="hidden md:flex">
      <button type="button" className={buttonClass} onClick={handleZoomIn} aria-label="Zoom in">
        <Icon i="zoom-in" className="size-5" />
      </button>
      <div className="border-t border-border" />
      <button type="button" className={buttonClass} onClick={handleZoomOut} aria-label="Zoom out">
        <Icon i="zoom-out" className="size-5" />
      </button>
    </ControlGroup>
  );
}
